<div class="Txt-Deposit-Coinbase">
  <h2>Bitcoin</h2>
  <span>{{ 'desc_deposit_coinbase' | t }}</span>

  <form class="example-form" [formGroup]="coinbaseDatas">
    <mat-form-field style="width: 100%">
      <input matInput placeholder="{{ 'Amount' | t }} ($)" type="number" formControlName="amount" />
    </mat-form-field>
  </form>

  <button mat-raised-button class="form-submit-button" (click)="submitCoinbaseData()" [disabled]="!coinbaseDatas.valid">{{ 'Pay' | t }}</button>
</div>
